import React, { useState, useEffect, useRef, useContext } from "react";
import "./KeevInner.css";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, signupUser } from '../../features/User/UserSlice';
import kiv_banner from "../../../../src/Images/New_Home/images/keev_banner.png";
import keev_offer from "../../../../src/Images/New_Home/images/keev_offer-1.png";
import keev_offer2 from "../../../../src/Images/New_Home/images/keev_offer-2.png";
import keev_offer3 from "../../../../src/Images/New_Home/images/keev_offer-3.png";
import keev_offer4 from "../../../../src/Images/New_Home/images/keev_offer-4.png";
import keev_offer5 from "../../../../src/Images/New_Home/images/keev_offer-5.png";
import keev_offer6 from "../../../../src/Images/New_Home/images/keev_offer-6.png";
import keev_work1 from "../../../../src/Images/New_Home/images/keev_work-1.png";
import keev_work2 from "../../../../src/Images/New_Home/images/keev_work-2.png";
import keev_work3 from "../../../../src/Images/New_Home/images/keev_work-3.png";
import keev_why1 from "../../../../src/Images/New_Home/images/keev_why-1.png";
import keev_why2 from "../../../../src/Images/New_Home/images/keev_why-2.png";
import keev_why3 from "../../../../src/Images/New_Home/images/keev_why-3.png";
import open_account from "../../../../src/Images/New_Home/images/open-account.png";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function KeevInner() {
    window.scrollTo(0, 0)
    const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const usrname = useSelector(state => state.user.email);
    const { isFetching, isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );

    useEffect(() => {
        if (isSuccess) {
            setShow(false);
        }
        if (isError) {
            dispatch(clearState());
        }
    }, [isSuccess, isError]);
    const clickToggleLoginPopup = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://moneysukh.keev.tech/',
                '_blank'
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
    CallTrackApi("Keev",window.location.href);

    return (
        <>
            <main class="keev-main">
                <section class="keev_banner-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div className="keev_banner">
                                    <div class="content">
                                        <div class="banner-head">
                                            No Coding
                                            <br></br><span class="text-blue">Algo Platform</span>
                                        </div>
                                        <p>Trade Radar is a platform that simplifies algorithm trading with amazing features like visualization, backtesting, optimization, virtual and live trading. Focus more on analysis and less on coding and developing the strategy.</p>
                                    </div>
                                    <div class="banner-img-container">
                                        <img src={kiv_banner} alt="image" class="img-fluid" />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section class="keev_offer-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="section-heading center">
                                    What Trade Radar offers
                                </div>
                                <div class="offer-grid-container">
                                    <div class="offer">
                                        <div class="img-container">
                                            <img src={keev_offer} alt="image" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Backtest</div>
                                            <p>No more guessing–create your strategy & test its results</p>
                                        </div>
                                    </div>
                                    <div class="offer">
                                        <div class="img-container">
                                            <img src={keev_offer2} alt="image" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Optimize</div>
                                            <p>Get the best possible returns with lowest losses</p>
                                        </div>
                                    </div>
                                    <div class="offer">
                                        <div class="img-container">
                                            <img src={keev_offer3} alt="image" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Automate</div>
                                            <p>Automate your TradingView / Chartink strategies</p>
                                        </div>
                                    </div>
                                    <div class="offer">
                                        <div class="img-container">
                                            <img src={keev_offer4} alt="image" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Automated Live
                                                Trading</div>
                                            <p>Stop spending hours in front of the screen</p>
                                        </div>
                                    </div>
                                    <div class="offer">
                                        <div class="img-container">
                                            <img src={keev_offer5} alt="image" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Multiple
                                                Segments</div>
                                            <p>Trade in equity, futures & options.</p>
                                        </div>
                                    </div>
                                    <div class="offer">
                                        <div class="img-container">
                                            <img src={keev_offer6} alt="image" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Limit order
                                                placement</div>
                                            <p>You can place limit orders to execute your trades at your given price</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="keev_work-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="section-heading center">
                                    How it works
                                </div>
                                <div class="work-container">
                                    <div class="work">
                                        <div class="img-container">
                                            <img src={keev_work1} alt="image" class="img-fluid" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Join Us</div>
                                            <p>
                                                Sign up with moneysukh for free
                                                and start using our services
                                            </p>
                                        </div>
                                    </div>
                                    <div class="work">
                                        <div class="img-container">
                                            <img src={keev_work2} alt="image" class="img-fluid" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Create Your Own Strategy</div>
                                            <p>
                                            Create your strategy, Backtest and Automate
                                            </p>
                                        </div>
                                    </div>
                                    <div class="work">
                                        <div class="img-container">
                                            <img src={keev_work3} alt="image" class="img-fluid" />
                                        </div>
                                        <div class="content">
                                            <div class="head">Sit Back and Relax</div>
                                            <p>
                                                Relax after creating strategy as our systems do all the work
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="keev_why-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="section-heading center">
                                    Why Trade Radar is better than <br></br>
                                    your manual Trading
                                </div>
                                <div class="why-container">
                                    <div class="why-card">
                                        <div class="img-container">
                                            <img src={keev_why1} alt="image" />
                                        </div>
                                        <div class="head">No Human Error</div>
                                        <p>Exact criteria & inputs are executed every single time</p>
                                    </div>
                                    <div class="why-card">
                                        <div class="img-container">
                                            <img src={keev_why2} alt="image" />
                                        </div>
                                        <div class="head">Works while you sleep</div>
                                        <p>No need to track every market move</p>
                                    </div>
                                    <div class="why-card">
                                        <div class="img-container">
                                            <img src={keev_why3} alt="image" />
                                        </div>
                                        <div class="head">100% private & secure</div>
                                        <p>Robust servers & end-to-end encryption</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="open-account-sc">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="head">Open Your Account</div>
                                <div class="img-container">
                                    <img src={open_account} alt="image" />
                                </div>
                                <button class="bttn" onClick={() => clickToggleLoginPopup(true)}>
                                    Get started
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
                <LoginPopup show={show} ref={childRef} />


            </main>
        </>
    );
}
export default KeevInner;

{/* <script src="https://code.jquery.com/jquery-3.2.1.slim.min.js"
        integrity="sha384-KJ3o2DKtIkvYIK3UENzmM7KCkRr/rE9/Qpg6aAZGJwFDMVNA/GpGFF93hXpG5KkN"
        crossorigin="anonymous"></script>
    <script src="https://cdn.jsdelivr.net/npm/popper.js@1.12.9/dist/umd/popper.min.js"
        integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q"
        crossorigin="anonymous"></script>
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@4.0.0/dist/js/bootstrap.min.js"
        integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl"
        crossorigin="anonymous"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js"
        integrity="sha512-XtmMtDEcNz2j7ekrtHvOVR4iwwaD6o/FUJe6+Zq+HgcCsk3kj4uSQQR8weQ2QVj1o0Pk6PwYLohm206ZzNfubg=="
        crossorigin="anonymous" referrerpolicy="no-referrer"></script>

    <!-- <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.js"
        integrity="sha512-WNZwVebQjhSxEzwbettGuQgWxbpYdoLf7mH+25A7sfQbbxKeS5SQ9QBf97zOY4nOlwtksgDA/czSTmfj4DUEiQ=="
        crossorigin="anonymous" referrerpolicy="no-referrer"></script> -->

    <script>

        $('.banner-slider').slick({
            dots: true,
            infinite: true,
            speed: 1000,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            // adaptiveHeight: true,
        });
        
    </script> */}


